import axios from 'axios';
import { Code } from 'constants/codes';
import { Utility } from 'helpers/UtilityHelpers';
import { Message } from 'constants/messages';

export const GenerateAccessToken = async (refreshToken: string | null): Promise<string> => {
    try {
      //generate access token from refresh token
      const response = await axios.post(Code.Path.SERVER + 'auth/GenerateAccessToken', 
        { refreshToken }, 
        { headers: { 'Content-Type': 'application/json' } }
      );
      //new access token is returned
      return response.data.accessToken;
    } 
    catch (error: any) {
      console.error(Message.Title.TOKEN_ERROR, error.message);
      return Promise.reject(error);
    }
  };

// Generate Access Token if not found or expired, and save it to storage.
export const GetAccessToken = async (): Promise<string> => {
  
  //get access token from storage
  let accessToken = Utility.Storage.Get(Code.LocalKey.AccessToken);

  if (!accessToken) {
    console.error(Message.Title.TOKEN_NOT_FOUND);
    throw new Error(Message.Title.TOKEN_NOT_FOUND);
  }

  //console.log(Message.Title.ACCESS_TOKEN, accessToken);

  if (!Utility.isValid.AccessToken(accessToken)) {
    //console.log(Message.Title.TOKEN_EXPIRED);

    const refreshToken = Utility.Storage.Get(Code.LocalKey.RefreshToken);

    if (!refreshToken) {
      console.error(Message.Title.TOKEN_NOT_FOUND);
      throw new Error(Message.Title.TOKEN_NOT_FOUND);
    }

    if (!Utility.isValid.RefreshToken(refreshToken)) {
        //console.log(Message.Title.TOKEN_EXPIRED);
    }

    // Generate a new access token
    accessToken = await GenerateAccessToken(refreshToken);

    // Save the new access token to storage
    localStorage.setItem(Code.LocalKey.AccessToken, accessToken);
  } 
  else {
    //console.log(Message.Title.TOKEN_VALID);
  }

  return accessToken;
};

// Create an Axios instance
export const apiClient = axios.create({
  baseURL: Code.Path.SERVER, // current server
  timeout: 10000, // requests timeout in 10 seconds
});

// Request interceptor for API calls
apiClient.interceptors.request.use(
  async (config) => {
    try {
      // Fetch the access token
      const accessToken = await GetAccessToken();
      
      // Attach the token to the Authorization header
      if (accessToken && config.headers) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
      //send the request
      return config;
    } 
    catch (error) {
      console.error(Message.Title.INTERCEPTOR_ERROR, error);
      return Promise.reject(error);
    }
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {

    // Log or handle specific HTTP error responses
    if (error.response?.status === 401) {
      console.error(Message.Title.UNAUTHORIZED_LOGIN);
      // Redirect to the login page
    }

    return Promise.reject(error);
  }
);

// Create an Axios instance
export const apiFileUpload = axios.create({
  baseURL: Code.Path.SERVER, // current server
  headers: {
    'Content-Type': 'multipart/form-data',
  },
  timeout: 10000, // requests timeout in 10 seconds
});

// Request interceptor for API calls
apiFileUpload.interceptors.request.use(
  async (config) => {
    try {
      // Fetch the access token
      const accessToken = await GetAccessToken();
      
      // Attach the token to the Authorization header
      if (accessToken && config.headers) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
      //send the request
      return config;
    } 
    catch (error) {
      console.error(Message.Title.INTERCEPTOR_ERROR, error);
      return Promise.reject(error);
    }
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

// Response interceptor
apiFileUpload.interceptors.response.use(
  (response) => response,
  (error) => {

    // Log or handle specific HTTP error responses
    if (error.response?.status === 401) {
      console.error(Message.Title.UNAUTHORIZED_LOGIN);
      // Redirect to the login page
    }

    return Promise.reject(error);
  }
);
